/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/button-has-type */

import * as React from 'react';
import { MediaPreviewState } from 'stageclip-common';

import DownloadButton from 'components/buttons/downloadButton';
import styles from './videoClipPreviewCell.module.scss';

interface VideoPreviewStateOwnProps {
  state: MediaPreviewState;
  link: string;
}

export class VideoClipPreviewCell extends React.Component<VideoPreviewStateOwnProps> {
  private renderState(state: MediaPreviewState, link: string) {
    switch (state) {
      case MediaPreviewState.NotAvailable:
        return <span className={styles.notAvailable}>Not Available</span>;
      case MediaPreviewState.Error:
        return <span className={styles.error}>Error</span>;
      case MediaPreviewState.Processing:
        return <span className={styles.processing}>Processing</span>;
      case MediaPreviewState.SentToGenerator:
        return <span className={styles.sentToGenerator}>Sent to generator</span>;
      case MediaPreviewState.Available:
        return <DownloadButton url={link} />;
      default:
        return '';
    }
  }

  public render() {
    return <div> {this.renderState(this.props.state, this.props.link)} </div>;
  }
}
